import './toggle-icon-button.scss';

import { kebabCase } from 'lodash';
import { MouseEvent, useCallback } from 'react';

import { ButtonIcon } from '../button/button';

export type ToggleIconButtonProps = {
  icon: ButtonIcon;
  active: boolean;
  onClick: (e: MouseEvent<HTMLButtonElement>) => void;
  variant?: 'positive' | 'negative';
  disabled?: boolean;
  className?: string;
};

export function ToggleIconButton({
  icon,
  active,
  onClick,
  variant,
  disabled = false,
  className,
}: ToggleIconButtonProps) {
  const onHandleClick = useCallback(
    (e: MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      e.stopPropagation();
      onClick(e);
    },
    [onClick]
  );

  return (
    <button
      type="button"
      className={`toggle-icon-button ${kebabCase(variant ?? '')}${
        active ? ' active' : ''
      }${className ? ` ${className}` : ''}`}
      disabled={disabled}
      onClick={onHandleClick}
    >
      <i className={`icon ${kebabCase(icon)}`} />
    </button>
  );
}
